<template>
  <div v-if="!isMobile">
    <s-modal
      cluster="k"
      :value="isShownWhatsappInputDialog"
      title="Jangan Sampai Terlewat"
      showCloseIcon
      showBackIcon
      @close="saveSettings('dismissed')"
    >
      <whatsapp-content @input="getUpdatedPhoneNumber" @validate="validatePhoneNumber" />
      <template #footer>
        <div class="text-center">
          <s-button id="web-submit-input-whatsapp" :disabled="!isValidPhoneNumber" class="submit" :class="btnSubmitClass" :loading="isLoading" cluster="k" @click="saveSettings">Simpan</s-button>
        </div>
      </template>
    </s-modal>
  </div>
</template>

<script>
import WhatsappContent from '@/components/dialog/whatsapp/Content.vue'
import inputWhatsappMixins from '@/mixins/inputWhatsapp.js'

export default {
  name: 'ModalWhatsappInput',
  mixins: [inputWhatsappMixins],
  components: {
    WhatsappContent
  }
}
</script>

<style scoped>
.submit {
  width: 100%;
  max-width: 360px;
}

::v-deep .s-modal-container .s-modal-header .s-modal-close-icon {
  top: -12px;
}

::v-deep .k-input {
  margin-bottom: 16px;
}
</style>
